// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"9312c437","224":"502cb127","751":"8aaaef26","787":"3fefa5cf"}[chunkId] + ".chunk.js";
};